
export const formatToCurrencyCeil = (num?: string): string => {
    if (!num) return '';
    const [integer, decimal] = num.split('.');
    const formattedInteger = Number(integer.replace(/,/g, '')).toLocaleString('en-US');
    return decimal !== undefined ? `${formattedInteger}.${decimal.substring(0, 2)}` : formattedInteger;
  };